import request from '@/CommonDP/utils/request';
//文档权限模块接口
export default {
  // 获取专业对应文档权限 企业级
  getListForCheckedSpec(params) {
    return request.post(`/enterpriseFolderPrivi/getListForCheckedSpec`, params)
  },
  // 获取专业角色对应文档权限 企业级
  getListForCheckedRole(params) {
    return request.post(`/enterpriseFolderPrivi/getListForCheckedRole`, params)
  },
  // 保存文档权限 企业级
  updateListForCheckedRole(params) {
    return request.post(`/enterpriseFolderPrivi/update`, params)
  },

  // 获取专业对应文档权限 项目级
  docPermissionFolderList(params) {
    return request.post(`/doc/permission/folder-role-list`, params)
  },
  // 保存问价夹权限 项目级
  updatePermissionOperation(params) {
    return request.post(`/doc/permission/operation`, params)
  },
  updatePermissionUpdate(params) {
    return request.post(`/doc/permission/update`, params)
  },
  // 查询文件夹权限
  docPermissionQuery(folderId, userType) {
    return request.get(`/doc/permission/query?userType=${userType}&folderId=${folderId}`)
  },
  // 查询项目成员
  getProjectUsers(prjId) {
    return request.get(`/project/getProjectUsers?projectId=${prjId}`)
  },

  // 查询项目专业
  specpermissionlist(prjId,folderId) {
    return request.get(`/doc/permission/spec-list?prjId=${prjId}&folderId=${folderId}`)
  },

   // 同步角色权限
  permissionRenew(params) {
    return request.post(`/doc/permission/renew`,params)
  },

  // [项目策划] 获取项目角色权限
  getPrjRolePermission(params) {
    return request.post('/prj-plan/prj-role-auth',params)
  },

  // [项目策划] 保存编辑的项目角色权限
  savePrjRolePermission(params) {
    return request.post('/prj-plan/edit-prj-role-auth', params)
  },

  // [项目策划] 同步角色权限
  syncRolePermission(params) {
    return request.post('/prj-plan/permission/renew', params)
  }

}

